<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card  grid-list-md>
      <v-card-title class="text-h5">New Attachment</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5">
        <v-row>
          <v-col sm="12">
            <v-text-field
              :error-messages="nameErrors" :hide-details="nameErrors.length === 0"
              v-model="Attachment.name" outlined dense
              label="Name"
            >
            </v-text-field
          ></v-col>
        </v-row>
        <v-card-text>
          <v-layout align-center justify-center column fill-height>
            <v-card
              outlined
              height="340"
              width="340"
              color="grey lighten-4"
              @click="pickFile"
              hover
            >
              <v-layout align-center justify-center column fill-height>
                <v-flex shrink v-if="!imageUrl">
                  <div class="text-center">
                    <v-icon size="100">mdi-cloud-upload-outline</v-icon>
                    <div>Click here to upload image</div>
                  </div>
                </v-flex>
                <img height="340" width="340" :src="imageUrl" v-else />
              </v-layout>
            </v-card>
          </v-layout>
          <input
            type="file"
            style="display: none;"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          />
        </v-card-text>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Close</v-btn>
        <v-btn color="green darken-1" text :loading="loading" @click="submit">Upload</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import attachmentService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-attachment",
  props: {
    createDialog: {
      default: false
    },
    employeeId: {
      default: null
    },
  },
  data() {
    return {
      imageName: "",
      imageUrl: "",
      imageFile: null,
      loading: false,
      dialog: false,
      Attachment: {
        name: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Attachment: {
      name: { required }
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Attachment.name.$dirty) return errors;
      if (!this.$v.Attachment.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    EmployeeId() {
      return this.employeeId;
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) return;
        
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
        });
        
        this.imageFile = files[0];
        
        if (!this.Attachment.name) {
            this.Attachment.name = this.imageName.split('.').slice(0, -1).join('.');
        }

      } else {
        this.imageName = "";
        this.imageFile = null;
        this.imageUrl = "";
      }
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Attachment.name = null;
      this.imageUrl = "";
      this.imageName = "";
      this.imageFile = null;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.imageFile) {
        this.$toast.error("Invalid Fields", {
          timeout: 2000,
        });
        if (!this.imageFile) {
          this.$toast.error("Please select an image to upload", {
            timeout: 2000,
          });
        }
        return;
      }

      this.loading = true;
      const attachmentData = {
        name: this.Attachment.name,
        file: this.imageFile,
        EmployeeId: this.EmployeeId,
      };

      return attachmentService
        .uploadAndCreate(attachmentData)
        .then((result) => {
          if (result.status) {
            this.$toast.success("Attachment is Uploaded Succesfully!", {
              timeout: 2000,
            });
            this.loading = false;
            this.$emit("submit");
            this.close();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 2000,
          });
        });
    }
  }
};
</script>

<style scoped></style>
